import { render, staticRenderFns } from "./personalData.vue?vue&type=template&id=2c69a9fc&scoped=true&"
import script from "./personalData.vue?vue&type=script&lang=js&"
export * from "./personalData.vue?vue&type=script&lang=js&"
import style0 from "./personalData.vue?vue&type=style&index=0&lang=css&"
import style1 from "./personalData.vue?vue&type=style&index=1&id=2c69a9fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c69a9fc",
  null
  
)

export default component.exports